import React, { Component } from 'react';
import { connect } from 'react-redux';
import './GeneralContractorTeam.css';
import {
  loadUserFormRequest,
  loadUsersRequest,
  setCurrentUserId,
  setShowInviteUserModal,
  goToEditGeneralContractorTeam,
} from 'actions/admin/team/general-contractor-team';
import { loadGeneralContractorRequest } from 'components/admin/general-contractors/store/actions.js';
import { UserModalState } from 'components/shared/modal/InviteUserModal';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import DetailsHeader from 'components/shared/details/DetailsHeader';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import DetailsInfo from 'components/shared/details/DetailsInfo';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import UserStatus from 'components/shared/text/UserStatus';
import { GENERAL_CONTRACTOR_ROLES, TYPES } from 'services/utils/users-util';
import { getCurrentGeneralContractor } from 'components/admin/general-contractors/store/selectors';
import { getCurrentUser } from 'selectors/authentication';
import { getUsers } from 'selectors/admin/team/general-contractor-team';
import SimpleTable from 'components/shared/table/SimpleTable';
import GeneralContractorTeamUserModalContainer from 'components/admin/team/GeneralContractorTeamUserModalContainer';
import { formatPhoneNumber } from 'services/utils/text-util';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import { usersApi } from 'services/api/users-api';

class GeneralContractorTeam extends Component {
  constructor(props) {
    super(props);
    this.generalContractorId = this.props.currentUser.accountable_id;
  }

  componentDidMount() {
    this.props
      .dispatch(loadGeneralContractorRequest(this.generalContractorId))
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(loadUsersRequest());
        }
      });
  }

  handleInviteUser = (event) => {
    event.preventDefault();
    this.props.dispatch(setCurrentUserId(0));
    this.props.dispatch(loadUserFormRequest(null));
    this.props.dispatch(setShowInviteUserModal(true, UserModalState.NEW));
  };

  handleSelectUser = (user) => {
    this.props.dispatch(setCurrentUserId(user.id));
    this.props.dispatch(loadUserFormRequest(user));
    this.props.dispatch(setShowInviteUserModal(true, UserModalState.READ_ONLY));
  };

  handleEdit = () => {
    this.props.dispatch(goToEditGeneralContractorTeam());
  };

  handleResendInvite = (id) => {
    usersApi.resendInvite(id);
  };

  actionBtns(currentUser, user) {
    return (
      <div className="action-btns-wrapper">
        <span
          className="linkable action-btn"
          onClick={() => this.handleSelectUser(user)}
        >
          Edit
        </span>
        {usersApi.resendInviteLink(currentUser, user) ? (
          <span
            className="linkable action-btn"
            onClick={() => this.handleResendInvite(user.id)}
          >
            Resend Invite
          </span>
        ) : (
          ''
        )}
      </div>
    );
  }

  render() {
    let detailsInfoItems = [];

    if (this.props.generalContractor) {
      if (this.props.generalContractor.location) {
        detailsInfoItems.push(
          <DetailsInfoItem
            lines={[
              this.props.generalContractor.location.street_address_1,
              this.props.generalContractor.location.city +
                ', ' +
                this.props.generalContractor.location.state +
                ' ' +
                this.props.generalContractor.location.zip,
            ]}
            title="ADDRESS"
          />
        );
      }

      detailsInfoItems.push(
        <DetailsInfoItem
          lines={[
            <span className="general-contractor-name">
              {`${this.props.generalContractor.contact.first_name} ${this.props.generalContractor.contact.last_name}`}
            </span>,
            <a
              className="general-contractor-email"
              href={`mailto:${this.props.generalContractor.contact.email}`}
            >
              {this.props.generalContractor.contact.email}
            </a>,
            formatPhoneNumber(
              this.props.generalContractor.contact.phone_number
            ),
          ]}
          title="PRIMARY CONTACT"
        />
      );

      detailsInfoItems.push(
        <DetailsInfoItem
          lines={[this.props.generalContractor.license_number]}
          title="LICENSE NUMBER"
        />
      );
    }

    return (
      this.props.generalContractor !== null && (
        <div className="team">
          <RouteTitle
            titles={[
              'COMPANY',
              this.props.generalContractor.name.toUpperCase(),
            ]}
          />

          <DetailsHeader
            leftHeader={{
              title: 'COMPANY',
              value: this.props.generalContractor.name,
            }}
            leftHeaderExtraComponents={
              this.props.generalContractor.logo &&
              this.props.generalContractor.logo.image && (
                <div className="logo-preview-container">
                  <LogoUpload
                    extensions={['.jpg', '.jpeg', '.gif', '.png']}
                    logos={[
                      {
                        preview: this.props.generalContractor.logo.image.url,
                        url: this.props.generalContractor.logo.image.url,
                      },
                    ]}
                    readOnly={true}
                  />
                </div>
              )
            }
            rightHeaders={[
              [
                {
                  title: 'STATUS',
                  value: (
                    <ContractorStatus
                      status={this.props.generalContractor.status}
                    />
                  ),
                },
              ],
            ]}
          />

          <div className="details-info-container">
            <DetailsInfo
              itemsContainerSize={12}
              itemsLines={[detailsInfoItems]}
            />
            <div className="edit-button-container">
              <input
                type="button"
                className="btn button button-gray"
                value="Edit"
                onClick={this.handleEdit}
              />
            </div>
          </div>

          <div className="content-container">
            <div className="invite-container">
              <input
                type="button"
                className="btn button button-orange"
                value="Invite"
                onClick={this.handleInviteUser}
              />
            </div>

            <SimpleTable
              className="users-table"
              headers={[
                'NAME',
                'TITLE',
                'STATUS',
                'PHONE NUMBER',
                'EMAIL',
                'ACTIONS',
              ]}
              rows={this.mapUsers(this.props.users)}
              emptyMessage="No Users"
            />
          </div>

          <GeneralContractorTeamUserModalContainer />
        </div>
      )
    );
  }

  mapUsers(users) {
    const { currentUser } = this.props;

    return users.map((user) => {
      let status;
      if (
        user.invitation_sent_at === null ||
        user.invitation_accepted_at !== null
      ) {
        status = user.status;
      } else if (user.invitation_accepted_at === null) {
        status = 'pending_invitation';
      }

      return [
        <span className="h4">{`${user.first_name} ${user.last_name}`}</span>,
        this.mapTitle(user.roles),
        <UserStatus status={status} />,
        user.phone_number !== null
          ? formatPhoneNumber(user.phone_number)
          : 'N/A',
        <a href={`mailto:${user.email}`} className="mailto">
          {user.email}
        </a>,
        this.actionBtns(currentUser, user),
      ];
    });
  }

  mapTitle(roles) {
    const titles = roles
      .filter((role) => role.resource_type === TYPES.GENERAL_CONTRACTOR)
      .map((role) => {
        return GENERAL_CONTRACTOR_ROLES[role.name];
      });

    if (titles.length > 1) {
      return titles.join(' / ');
    } else if (titles.length === 1) {
      return titles[0];
    } else {
      return 'N/A';
    }
  }
}

export default connect((state) => {
  return {
    generalContractor: getCurrentGeneralContractor(state),
    currentUser: getCurrentUser(state),
    users: getUsers(state),
  };
})(GeneralContractorTeam);



// WEBPACK FOOTER //
// ./src/components/admin/team/GeneralContractorTeam.js